import React from 'react';
import Hero from './components/admission/Hero';
import Main from './components/admission/Main';
import ImportantLinksSlider from '../src/components/Home/ImportantLinksSlider';

const Admission = () => {
  return (
    <div>
        <Hero/>
        <Main/>
        <ImportantLinksSlider/>
    </div>
  )
}

export default Admission;